// extracted by mini-css-extract-plugin
export var columnItem = "_bz-3";
export var columnItemDraggable = "_bz-4";
export var dragHandle = "_bz-0";
export var dragHandleHovered = "_bz-1";
export var dropdown = "_bz-5";
export var dropdownContent = "_bz-7";
export var dropdownInner = "_bz-6";
export var filterDropdownHeader = "_bz-8";
export var icon = "_bz-2";
export var sectionDivider = "_bz-9";